import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import _ from 'lodash'

function mapStateToProps(state, props) {
    const entId = _.get(props, 'id', null)
    const module = _.get(props, 'module', null)

    return {
        selectedLanguage: state.getIn(['translate', 'locale']),
        entity: state.getIn(['ui', 'modules', module, 'workspace', entId, 'entity']),
    }
}

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({}, dispatch);
// }

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
